import * as React from "react";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { PropertyFiltersComponentProps } from "../typings";
import { UitkRadioButton, UitkRadioButtonGroup } from "uitk-react-radio-button";
import { withStores } from "src/stores";
import { observer } from "mobx-react";
import { UitkSpacing } from "uitk-react-spacing";

export const Radio = withStores("propertyFilters")(
  observer((props: PropertyFiltersComponentProps) => {
    const { filterName, option, propertyFilters, moduleName } = props;
    const { optionValue, description, label } = option;

    const track = useClickTracker();

    const onChange = () => {
      const rfrr = `${moduleName}.${moduleName}.${filterName}.${optionValue}.${!isSelected}.click`;
      const linkName = "RFRR Action Link";
      track(rfrr, linkName);

      propertyFilters.toggleSelection(filterName, optionValue ?? "");
    };

    const isSelected = propertyFilters.isSelected(filterName, optionValue ?? "");

    return (
      <UitkSpacing margin="half">
        <UitkRadioButtonGroup group={`${filterName}-${optionValue}`} onChange={onChange}>
          <UitkRadioButton
            id={`${filterName}-${optionValue}`}
            value={optionValue ?? ""}
            checked={isSelected}
            description={description ?? ""}
          >
            {label}
          </UitkRadioButton>
        </UitkRadioButtonGroup>
      </UitkSpacing>
    );
  })
);
